// import React from "react";
// import { Link } from "react-router-dom";

// export default function Footer() {
//   return (
//     <footer className="bg-slate-950 text-slate-200 mt-auto">
//       <div className="mx-auto max-w-7xl px-4 py-10 grid grid-cols-2 md:grid-cols-4 gap-6">
//         <div>
//           <Link to="/" className="flex items-center gap-2 cursor-pointer">
//             <div className="h-9 w-9 rounded-xl bg-amber-400 grid place-items-center font-black text-slate-900 shadow-md">🎟️</div>
//             <span className="text-2xl font-extrabold tracking-tight text-slate-900">
//               <span className="text-amber-500">Show</span>
//               <span className="text-white">Time</span>
//               <span className="text-amber-500">Bro</span>
//             </span>
//           </Link>
//           <p className="text-sm text-slate-400 mt-2">Made with ❤️ in India</p>
//         </div>

//         <div>
//           <div className="font-semibold mb-2">Discover</div>
//           <ul className="space-y-1 text-sm text-slate-400">
//             <li><a href="/#featured" className="hover:text-white">Featured</a></li>
//             <li><a href="/#trending" className="hover:text-white">Trending</a></li>
//             <li><a href="/#weekend" className="hover:text-white">This Weekend</a></li>
//           </ul>
//         </div>

//         <div>
//           <div className="font-semibold mb-2">Company</div>
//           <ul className="space-y-1 text-sm text-slate-400">
//             <li><Link to="/about" className="hover:text-white">About</Link></li>
//             {/* <li><Link to="/careers" className="hover:text-white">Careers</Link></li> */}
//             <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
//           </ul>
//         </div>

//         <div>
//           <div className="font-semibold mb-2">Legal</div>
//           <ul className="space-y-1 text-sm text-slate-400">
//             <li><a className="hover:text-white">Terms</a></li>
//             <li><a className="hover:text-white">Privacy</a></li>
//             {/* <li><a className="hover:text-white">Cookies</a></li> */}
//           </ul>
//         </div>
//       </div>
//       <div className="border-t border-white/10 py-4 text-center text-xs text-slate-500">
//         © {new Date().getFullYear()} ShowTimeBro. All rights reserved.
//       </div>
//     </footer>
//   );
// }


// import React from "react";
// import { Link } from "react-router-dom";
// import logo from "../assets/logo2.png"; // your full-size logo

// function SocialIcon({ children, href, label }) {
//   return (
//     <a
//       href={href}
//       aria-label={label}
//       target="_blank"
//       rel="noreferrer"
//       className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/5 hover:bg-white/10 ring-1 ring-white/10 transition"
//     >
//       {children}
//     </a>
//   );
// }

// function BrandLogo({
//   src,
//   alt = "ShowTimeBro",
//   heightClass = "h-12 md:h-14 lg:h-16", // control size here
// }) {
//   return (
//     <div className="flex items-center gap-3">
//       {src ? (
//         <img
//           src={src}
//           alt={alt}
//           className={`${heightClass} w-auto object-contain`}
//           loading="lazy"
//         />
//       ) : (
//         <div
//           className={`${heightClass} aspect-square grid place-items-center rounded-2xl bg-white/5 ring-1 ring-white/10`}
//         >
//           <span className="text-xl">🎟️</span>
//         </div>
//       )}
//       <span className="sr-only">{alt}</span>
//     </div>
//   );
// }

// export default function Footer() {
//   const year = new Date().getFullYear();

//   return (
//     <footer className="relative mt-auto">
//       {/* background */}
//       <div className="absolute inset-0 bg-slate-950" />
//       <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 via-transparent to-transparent" />
//       {/* subtle top divider glow */}
//       <div className="absolute -top-px left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />

//       <div className="relative mx-auto max-w-7xl px-4">
//         {/* top strip */}
//         <div className="flex flex-col items-start justify-between gap-4 border-b border-white/10 py-8 md:flex-row">
//           <Link to="/" className="flex items-center gap-3">
           
//             <BrandLogo src={logo} alt="ShowTimeBro" />
       
//           </Link>

//           <div className="flex items-center gap-3">
//             {/* <AppBadge type="play" />
//             <AppBadge type="apple" /> */}
//           </div>
//         </div>

//         {/* main grid */}
//         <div className="grid grid-cols-2 gap-8 py-10 text-sm text-slate-300 md:grid-cols-4">
//           <div>
//             <div className="font-semibold text-white">Discover</div>
//             <ul className="mt-3 space-y-2">
//               <li><a href="/#featured" className="hover:text-white">Featured</a></li>
//               <li><a href="/#trending" className="hover:text-white">Trending</a></li>
//               <li><a href="/#weekend" className="hover:text-white">This Weekend</a></li>
//             </ul>
//           </div>

//           <div>
//             <div className="font-semibold text-white">Company</div>
//             <ul className="mt-3 space-y-2">
//               <li><Link to="/about" className="hover:text-white">About Us</Link></li>
//               <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
//               <li><Link to="/faq" className="hover:text-white">FAQ</Link></li>
//             </ul>
//           </div>

//           <div>
//             <div className="font-semibold text-white">Legal</div>
//             <ul className="mt-3 space-y-2">
//               <li><a href="/terms-and-condition" className="hover:text-white">Terms & condition</a></li>
//               <li><a href="/privacy-policy" className="hover:text-white">Privacy Policy</a></li>
//               <li><a href="/shipping" className="hover:text-white">Shipping & Delivery Policy</a></li>
//               <li><a href="/cancellation" className="hover:text-white">Cancellation & Refund Policy</a></li>
//             </ul>
//           </div>

//           {/* newsletter */}
//           <div>
//             <div className="font-semibold text-white">Stay in the loop</div>
//             <p className="mt-3 text-slate-400">
//               Get updates on new events, offers, and more.
//             </p>
//             <form
//               onSubmit={(e) => e.preventDefault()}
//               className="mt-3 flex overflow-hidden rounded-xl ring-1 ring-white/15 focus-within:ring-amber-400/60"
//             >
//               <input
//                 type="email"
//                 className="w-full bg-white/5 px-3 py-2 text-slate-100 placeholder:text-slate-400 outline-none"
//                 placeholder="you@example.com"
//               />
//               <button
//                 className="bg-amber-400 px-4 text-sm font-semibold text-slate-900 hover:bg-amber-300"
//                 type="submit"
//               >
//                 Subscribe
//               </button>
//             </form>

//             <div className="mt-3 flex items-center gap-2 text-xs text-slate-400">
//               <span className="inline-block h-1.5 w-1.5 rounded-full bg-emerald-400" />
//               No spam. Unsubscribe anytime.
//             </div>
//           </div>
//         </div>

//         {/* bottom bar */}
//         <div className="flex flex-col-reverse items-center justify-between gap-4 border-t border-white/10 py-6 text-xs text-slate-400 md:flex-row">
//           <div>© {year} ShowTimeBro. All rights reserved. • Made with ❤️ in India</div>

//           <div className="flex items-center gap-3">
//             <SocialIcon href="https://twitter.com" label="Twitter">
//               <svg className="h-4 w-4 text-slate-200" viewBox="0 0 24 24" fill="currentColor"><path d="M23 4.5c-.8.4-1.7.7-2.6.8a4.5 4.5 0 0 0-7.8 4.1 12.8 12.8 0 0 1-9.3-4.7A4.5 4.5 0 0 0 4 11a4.4 4.4 0 0 1-2-.5 4.5 4.5 0 0 0 3.6 4.4 4.6 4.6 0 0 1-2 .1 4.5 4.5 0 0 0 4.2 3.1A9 9 0 0 1 2 20.6a12.7 12.7 0 0 0 6.9 2c8.3 0 12.8-6.9 12.8-12.8v-.6c.9-.6 1.6-1.4 2.3-2.3z" /></svg>
//             </SocialIcon>
//             <SocialIcon href="https://facebook.com" label="Facebook">
//               <svg className="h-4 w-4 text-slate-200" viewBox="0 0 24 24" fill="currentColor"><path d="M22 12a10 10 0 1 0-11.6 9.9v-7h-2.3V12h2.3V9.7c0-2.3 1.4-3.6 3.5-3.6 1 0 2 .2 2 .2v2.2h-1.1c-1.1 0-1.5.7-1.5 1.4V12h2.6l-.4 2.9h-2.2v7A10 10 0 0 0 22 12z" /></svg>
//             </SocialIcon>
//             <SocialIcon href="https://www.instagram.com/showtimebroo?igsh=MWhtODllcHRuN3hrbw==" label="Instagram">
//               <svg className="h-4 w-4 text-slate-200" viewBox="0 0 24 24" fill="currentColor"><path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm5 5.3A4.7 4.7 0 1 0 12 17.7 4.7 4.7 0 0 0 12 7.3zm6.1-.8a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2zM12 9.3a3.3 3.3 0 1 1 0 6.7 3.3 3.3 0 0 1 0-6.7z" /></svg>
//             </SocialIcon>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// }
// src/components/Footer.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo2.png"; // update path if needed

function SocialIcon({ children, href, label }) {
  return (
    <a
      href={href}
      aria-label={label}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/5 hover:bg-white/10 ring-1 ring-white/10 transition focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400"
    >
      {children}
    </a>
  );
}

function BrandLogo({ src, alt = "ShowTimeBro", heightClass = "h-10 md:h-11" }) {
  return (
    <div className="flex items-center gap-3">
      {src ? (
        <img
          src={src}
          alt={alt}
          className={`${heightClass} w-auto object-contain`}
          loading="lazy"
        />
      ) : (
        <div
          className={`${heightClass} aspect-square grid place-items-center rounded-2xl bg-white/5 ring-1 ring-white/10`}
          aria-hidden="true"
        >
          <span className="text-xl">🎟️</span>
        </div>
      )}
      <span className="sr-only">{alt}</span>
    </div>
  );
}

export default function Footer() {
  const year = new Date().getFullYear();
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null); // { type, text }
  const [submitting, setSubmitting] = useState(false);
  // Honeypot field for bots
  const [hp, setHp] = useState("");

  const validateEmail = (e) => {
    const re = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
    return re.test(e);
  };

  const handleSubscribe = async (ev) => {
    ev.preventDefault();
    setStatus(null);

    if (hp) {
      // bot - silently ignore
      return;
    }

    if (!email || !validateEmail(email)) {
      setStatus({ type: "error", text: "Please enter a valid email address." });
      return;
    }

    setSubmitting(true);
    try {
      // Replace '/api/subscribe' with your real subscribe endpoint
      const res = await fetch("/api/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      if (!res.ok) {
        throw new Error("Subscription failed");
      }

      setStatus({ type: "success", text: "Subscribed — check your inbox for confirmation." });
      setEmail("");
    } catch (err) {
      setStatus({ type: "error", text: "Something went wrong. Please try again later." });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="relative mt-auto text-slate-300">
      {/* decorative backgrounds */}
      <div className="absolute inset-0 bg-slate-950 pointer-events-none" />
      <div className="relative mx-auto max-w-7xl px-4">
        {/* top area */}
        <div className="flex flex-col items-start justify-between gap-4 border-b border-white/10 py-8 md:flex-row">
          <Link to="/" className="flex items-center gap-3">
            <BrandLogo src={logo} alt="ShowTimeBro" />
          </Link>

          <div className="flex items-center gap-3">
            {/* Place for app badges / other CTAs */}
          </div>
        </div>

        {/* main grid */}
        <div className="grid grid-cols-2 gap-6 py-8 text-sm md:grid-cols-4">
          <nav aria-labelledby="discover-heading">
            <h3 id="discover-heading" className="font-semibold text-white">Discover</h3>
            <ul className="mt-3 space-y-2">
              <li><a href="/#featured" className="hover:text-white">Featured</a></li>
              <li><a href="/#trending" className="hover:text-white">Trending</a></li>
              <li><a href="/#weekend" className="hover:text-white">This Weekend</a></li>
            </ul>
          </nav>

          <nav aria-labelledby="company-heading">
            <h3 id="company-heading" className="font-semibold text-white">Company</h3>
            <ul className="mt-3 space-y-2">
              <li><Link to="/about" className="hover:text-white">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
              <li><Link to="/faq" className="hover:text-white">FAQ</Link></li>
            </ul>
          </nav>

          <nav aria-labelledby="legal-heading">
            <h3 id="legal-heading" className="font-semibold text-white">Legal</h3>
            <ul className="mt-3 space-y-2">
              <li><Link to="/terms-of-use" className="hover:text-white">Terms of Use</Link></li>
              <li><Link to="/privacy-policy" className="hover:text-white">Privacy Policy</Link></li>
              <li><Link to="/shipping" className="hover:text-white">Shipping & Delivery</Link></li>
              <li><Link to="/cancellation" className="hover:text-white">Cancellation & Refund</Link></li>
            </ul>
          </nav>

          <div aria-labelledby="newsletter-heading">
            <h3 id="newsletter-heading" className="font-semibold text-white">Stay in the loop</h3>
            <p className="mt-3 text-slate-400">Get updates on new events, offers, and more.</p>

            <form
              onSubmit={handleSubscribe}
              className="mt-3 flex overflow-hidden rounded-xl ring-1 ring-white/15 focus-within:ring-amber-400/60"
              aria-label="Subscribe to newsletter"
            >
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-white/5 px-3 py-2 text-slate-100 placeholder:text-slate-400 outline-none"
                placeholder="you@example.com"
                aria-label="Email address"
                required
              />

              {/* honeypot - keep visually hidden */}
              <input
                type="text"
                name="website"
                value={hp}
                onChange={(e) => setHp(e.target.value)}
                className="sr-only"
                tabIndex="-1"
                autoComplete="off"
                aria-hidden="true"
              />

              <button
                className="bg-amber-400 px-4 text-sm font-semibold text-slate-900 hover:bg-amber-300 disabled:opacity-60"
                type="submit"
                disabled={submitting}
              >
                {submitting ? "Subscribing..." : "Subscribe"}
              </button>
            </form>

            <div className="mt-3 flex items-center gap-2 text-xs text-slate-400">
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-emerald-400" />
              No spam. Unsubscribe anytime.
            </div>

            <div className="mt-2" aria-live="polite">
              {status && (
                <p className={`text-sm ${status.type === "success" ? "text-green-400" : "text-rose-400"}`}>
                  {status.text}
                </p>
              )}
            </div>
          </div>
        </div>

        {/* bottom bar */}
        <div className="flex flex-col-reverse items-center justify-between gap-3 border-t border-white/10 py-5 text-xs md:flex-row">
          <div>© {year} ShowTimeBro. All rights reserved. • Made with ❤️ in India</div>

          <div className="flex items-center gap-3">
            <SocialIcon href="https://twitter.com" label="Twitter">
              <svg className="h-4 w-4 text-slate-200" viewBox="0 0 24 24" fill="currentColor"><path d="M23 4.5c-.8.4-1.7.7-2.6.8a4.5 4.5 0 0 0-7.8 4.1 12.8 12.8 0 0 1-9.3-4.7A4.5 4.5 0 0 0 4 11a4.4 4.4 0 0 1-2-.5 4.5 4.5 0 0 0 3.6 4.4 4.6 4.6 0 0 1-2 .1 4.5 4.5 0 0 0 4.2 3.1A9 9 0 0 1 2 20.6a12.7 12.7 0 0 0 6.9 2c8.3 0 12.8-6.9 12.8-12.8v-.6c.9-.6 1.6-1.4 2.3-2.3z" /></svg>
            </SocialIcon>
            <SocialIcon href="https://facebook.com" label="Facebook">
              <svg className="h-4 w-4 text-slate-200" viewBox="0 0 24 24" fill="currentColor"><path d="M22 12a10 10 0 1 0-11.6 9.9v-7h-2.3V12h2.3V9.7c0-2.3 1.4-3.6 3.5-3.6 1 0 2 .2 2 .2v2.2h-1.1c-1.1 0-1.5.7-1.5 1.4V12h2.6l-.4 2.9h-2.2v7A10 10 0 0 0 22 12z" /></svg>
            </SocialIcon>
            <SocialIcon href="https://www.instagram.com/showtimebro_official?igsh=MnlmeG5yMm81bTJw" label="Instagram">
              <svg className="h-4 w-4 text-slate-200" viewBox="0 0 24 24" fill="currentColor"><path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm5 5.3A4.7 4.7 0 1 0 12 17.7 4.7 4.7 0 0 0 12 7.3zm6.1-.8a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2zM12 9.3a3.3 3.3 0 1 1 0 6.7 3.3 3.3 0 0 1 0-6.7z" /></svg>
            </SocialIcon>
          </div>
        </div>
      </div>
    </footer>
  );
}
